import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import gtmEvents from 'shared/utils/gtm-events';
import { checkoutInitialState, SLICE_NAMESPACE } from '../constants';
import { ICheckoutState } from '../types';

export const purchaseOrderAction = createAsyncThunk(`${SLICE_NAMESPACE}/purchaseOrder`, async (_, { getState }) => {
  const { checkout, auth } = getState();
  const { shipping, paymentMethod, detail, agreements } = checkout;

  const response = await apiService.orders.createOrder({
    customer: auth.customer,
    order: {
      detail,
      paymentMethod,
      shipping,
      agreements,
    },
  });

  gtmEvents.triggerPurchaseEvent(response);

  return response;
});

export const purchaseOrderReducer: TSliceExtraReducer<ICheckoutState> = builder => {
  builder
    .addCase(purchaseOrderAction.pending, state => {
      state.status.submitting = true;
      state.status.completed = false;
    })
    .addCase(purchaseOrderAction.fulfilled, (state, { payload }) => {
      const { shipping, paymentMethod, detail } = checkoutInitialState;
      state.status.submitting = false;
      state.status.completed = true;
      state.orderSuccessDetail = payload;
      state.shipping.address = {};
      state.shipping.idle = true;
      state.shipping.deliveryDates = shipping.deliveryDates;
      state.paymentMethod = paymentMethod;
      state.detail = detail;
    })
    .addCase(purchaseOrderAction.rejected, state => {
      state.status.submitting = false;
      state.status.completed = false;
    });

  return builder;
};
